/**
 * @file 「大切にすること」の箇条書き (見出し + 本文 / 列挙)。
 *
 * @what: 各項目は 太字の見出し (lead) と、本文 (text) か列挙 (items) を持つ。列挙は「・」で
 *   つないだ文にせず、小さなラベルとして並べる (箇条書きの点と見分けがつかないため。代表の指摘、2026-08-24)。
 * @why: 計画の面と見取り図で同じ見た目にする。
 * @failure: 描画のみ。
 */

import type { StageFocus } from "../model";
import "./study.css";

export function FocusList({ focus }: { focus: StageFocus[] }) {
  return (
    <ul className="study-focus-list">
      {focus.map((f, i) => (
        <li key={`${i}:${f.lead ?? ""}:${f.text ?? ""}`}>
          {f.lead ? <b className="study-focus-lead">{f.lead}</b> : null}
          {f.text ? <span className="study-focus-text">{f.text}</span> : null}
          {f.items ? (
            <span className="study-focus-items">
              {f.items.map((it, j) => (
                <span key={`${j}:${it}`} className="study-focus-item">
                  {it}
                </span>
              ))}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
